import { cva } from 'class-variance-authority';
import { motion } from 'motion/react';
import type { VariantProps } from 'class-variance-authority';
const DescriptionVariantsvariants = cva('min-h-20 max-w-60 text-center font-sans text-base text-white', {
  variants: {
    variant: {
      initial: 'max-w-60',
      pending: 'max-w-60',
      error: 'max-w-80'
    }
  },
  defaultVariants: {
    variant: 'initial'
  }
});
interface OverlayDescriptionProps extends VariantProps<typeof DescriptionVariantsvariants> {
  children: React.ReactNode;
}
export const OverlayDescription = ({
  children,
  variant
}: OverlayDescriptionProps) => <motion.div animate={{
  opacity: 1,
  y: 0
}} className={DescriptionVariantsvariants({
  variant
})} exit={{
  opacity: 0,
  y: -4
}} initial={{
  opacity: 0,
  y: 4
}} key="stripe-overlay-description" layout transition={{
  duration: 0.3,
  delay: 0.2
}} data-sentry-element="motion.div" data-sentry-component="OverlayDescription" data-sentry-source-file="OverlayDescription.tsx">
    {children}
  </motion.div>;